import script from "./PhoneTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneTemplate.vue?vue&type=style&index=0&id=1328f266&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1328f266"]])

export default __exports__